import React from "react";
import HeroSection from "./HeroSection";
import WhyCertificates from "./WhyCertificates";
import OurCertificates from "./OurCertificates";
import GetCertificates from "./GetCertificates";
import CustomButton from "../ui/Button";
import { useTranslation } from "react-i18next";


const Certificates = () => {
  const { t,i18n } = useTranslation("certificates"); // Hook to use translations
  const isRussian = i18n.language === "ru"; // Check if the language is Russian

  return (
    <div>
      <HeroSection />
      <WhyCertificates />
      <OurCertificates />
      <GetCertificates />


      <div className="p-5 sm:p-[100px] flex flex-col justify-center items-center gap-5 text-center ellipsebg">

        <div className='max-w-[818px] flex flex-col justify-center items-center text-center gap-5'>
          <h1 className="web-heading-section px-12">
            {t("join_team")}
          </h1>
          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("join_team_description")}
          </p>
          <CustomButton>{t("contact_rd_team")}</CustomButton>

          <h2 className="title-xl-2">{t("spontaneous_applications")}</h2>

          <p className={`body-large-30 text-[#F0F0F0B2] ${isRussian ? 'lang-ru-contact-desc' : ''}`}>

            {t("spontaneous_applications_description")}
          </p>

        </div>

      </div>
    </div>
  );
};

export default Certificates;
